/* Optional, consent-gated telemetry. Never await this from a shopping operation. */
(() => {
 'use strict';let sent=0,active=0;
 function allowed(){return window.DluxcaUsageEnabled===true&&!window.Shopify?.designMode&&window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()===true;}
 function visitor(){
  try{const key='dluxca_usage_visitor_v1',now=Date.now();let d=JSON.parse(localStorage.getItem(key)||'null');
   if(!d||typeof d.id!=='string'||!/^[-a-zA-Z0-9]{16,64}$/.test(d.id)||!Number.isFinite(d.expires)||d.expires<now){d={id:crypto.randomUUID(),expires:now+90*86400000};localStorage.setItem(key,JSON.stringify(d));}return d.id;
  }catch(_){return null;}
 }
 window.DluxcaUsage={track(feature,outcome){
  try{
   if(!allowed()||sent>=100||active>=4)return;
   const id=visitor();if(!id)return;sent++;active++;
   const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),5000);
   fetch((window.Shopify?.routes?.root||'/')+'apps/saved-lists/usage/event',{
    method:'POST',credentials:'same-origin',keepalive:true,signal:controller.signal,
    headers:{'Content-Type':'application/json'},body:JSON.stringify({feature,outcome,consent:true,event_id:crypto.randomUUID(),visitor:id})
   }).catch(()=>{}).finally(()=>{clearTimeout(timer);active--;});
  }catch(_){}
 }};
 try{if(!window.Shopify?.customerPrivacy&&window.Shopify?.loadFeatures)window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],()=>{});}catch(_){}
 document.addEventListener('visitorConsentCollected',()=>{try{if(!allowed())localStorage.removeItem('dluxca_usage_visitor_v1');}catch(_){}});
})();
